import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { Chat } from '../../../api/chat/chat';
import { ChatService } from '../../../api/chat/chat.service';

var split = require('emoji-aware').split;
var onlyEmoji = require('emoji-aware').onlyEmoji;
import  '../../../assets/twemoji.js';
import  '../../../assets/lib/js/emoji-picker';

declare var $: any;
declare var jQuery: any;
declare var swal: any;
declare var emojiPicker: any;
declare var EmojiPicker: any;
declare var twemoji: any;

@Component({
    selector: 'chat-page',
    templateUrl: './chat.html'
})
export class ChatComponent implements OnInit {

    userchatList : any;
    userchatHistoryList : any;
    chatUserName : string = "";
    typingmessage : string = "";

    selecteduserlistData : any;

    currentMsgType : string = "";

    progressPer :string = "0%";

    constructor(private chatService: ChatService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            $(function () {
                // Initializes and creates emoji set from sprite sheet
                emojiPicker = new EmojiPicker({
                    //    iconSize:25,
                    emojiable_selector: '[data-emojiable=true]',
                    assetsPath: 'assets/lib/img/',
                    popupButtonClasses: 'fa fa-smile-o'
                });
                // Finds all elements with `emojiable_selector` and converts them to rich emoji input fields
                // You may want to delay this step if you have dynamically created input fields that appear later in the loading process
                // It can be called as many times as necessary; previously converted input fields will not be converted again
                emojiPicker.discover();
            });
            this.chatService.getUnReadMessageCounter.emit(0);
            this.progressPer = "0%";
            this.userchatList = [];
            this.userchatHistoryList = [];
            this.chatUserName = "";
            this.switchMessageType("New Message");
        } else {
            this.router.navigate(['/']);
        }
    }
    switchMessageType(tp)
    {
        this.progressPer = "25%";
        this.currentMsgType = tp;
        var jDDDD = {
            type : tp
        }
        this.chatService
        .allChat(jDDDD)
        .then(data => {
            this.progressPer = "100%";
            this.userchatList = data.data;
            this.userchatHistoryList = [];
            for (let index = 0; index < this.userchatList.length; index++) {
                const element = this.userchatList[index];
                if(element.username.trim() == "")
                {
                    this.userchatList[index].username = "Anonymous";
                }
            }
            this.progressTimeOut();
        });
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }
    userListClick(userlistData,i)
    {
        $(function () {
            $('.cat__apps__messaging__tab--selected').on('click', function () {
                $('.cat__apps__messaging__tab--selected').removeClass('cat__apps__messaging__tab');
                $(this).addClass('cat__apps__messaging__tab');
            });
            $('.cat__apps__messaging__tab').on('click', function () {
                $('.cat__apps__messaging__tab').removeClass('cat__apps__messaging__tab--selected');
                $(this).addClass('cat__apps__messaging__tab cat__apps__messaging__tab--selected');
            });
        });
        this.progressPer = "35%";
        this.userchatList[i].undreadmessages = 0;
        userlistData.undreadmessages = 0;
        this.selecteduserlistData = userlistData;
        this.chatUserName = "("+ userlistData.username+ ")";
        this.chatService
        .chatHistory(userlistData.userId)
        .then(data => {
            this.progressPer = "100%";
            this.userchatHistoryList = data.data;
            for (let index = 0; index < this.userchatHistoryList.length; index++) {
                this.userchatHistoryList[index]["username"] = userlistData.username;
                this.userchatHistoryList[index]["adminname"] = "Support";
                var emojiString = this.userchatHistoryList[index].message;
                var emojiStringadmin = this.userchatHistoryList[index].adminmessage;
                var n = this.userchatHistoryList[index].message.search("<img");
                var n2 = this.userchatHistoryList[index].adminmessage.search("<img");
                if (n == -1) {
                    this.userchatHistoryList[index]["message"] = twemoji.parse(unescapeUnicode(emojiString));
                }
                if (n2 == -1) {
                    this.userchatHistoryList[index]["adminmessage"] = twemoji.parse(unescapeUnicode(emojiStringadmin));
                }
            }
            $(function () {
                setTimeout(function () {
                    var elem = document.getElementById('foo');
                    elem.scrollTop = elem.scrollHeight;
                }, 0);
            })
            this.progressTimeOut();
        });
    }
    sendMessage()
    {
        if (this.typingmessage == undefined || this.typingmessage == "" || this.typingmessage == null) 
        {
            $.notify({
                message: "Please Enter Message"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        var result = split(this.typingmessage);
        var result2 = onlyEmoji(this.typingmessage);
        for (var i = 0; i < result.length; i++) {
            for (var j = 0; j < result2.length; j++) {
                if (result[i] === result2[j]) {
                    var converttodecimal = result[i].codePointAt(0);
                    result[i] = toUTF16(converttodecimal);
                }
            }
        }
        var emoji_str = result.join('');
        this.progressPer = "35%";
        var jDD = {
            message : emoji_str,
            userId : this.selecteduserlistData.userId,
            countrycode : this.selecteduserlistData.countrycode
        }
        this.chatService
        .sendMessage(jDD)
        .then(data => {
            this.progressPer = "100%";
            if(data.status)
            {
                data.data["username"] = this.selecteduserlistData.username;
                data.data["adminname"] = "Support";

                var emojiString = data.data["message"];
                var emojiStringadmin = data.data["adminmessage"];
                var n = data.data["message"].search("<img");
                var n2 = data.data["adminmessage"].search("<img");
                if (n == -1) {
                    data.data["message"] = twemoji.parse(unescapeUnicode(emojiString));
                }
                if (n2 == -1) {
                    data.data["adminmessage"] = twemoji.parse(unescapeUnicode(emojiStringadmin));
                }

                this.userchatHistoryList.push(data.data)
                $.notify({
                    message: "Message Successfully Sent"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
                $("#typingmessage").siblings(".emoji-wysiwyg-editor").children("img").remove();
                $(".emoji-wysiwyg-editor").empty();
                this.typingmessage = "";
                $(function () {
                    setTimeout(function () {
                        var elem = document.getElementById('foo');
                        elem.scrollTop = elem.scrollHeight;
                    },0);
                })
            }
            else
            {
                $.notify({
                    message: "Something wen't wrong. Try again after sometime"
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            }
            this.progressTimeOut();
        });
    }
    clearChatHistory()
    {
        this.progressPer = "25%";
        this.chatService
        .clearChatHistory(this.selecteduserlistData.userId)
        .then(data => {
            this.progressPer = "100%";
            this.userchatHistoryList = [];
            $.notify({
                message: "Chat History Successfully Deleted"
            }, {
                type: 'success',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            this.progressTimeOut();
        });
    }
    userDetailClicl()
    {
        this.router.navigate(['/user/'+this.selecteduserlistData.userId+'/MORE']);
    }
}
function unescapeUnicode(str) {
    return str.replace(/\\u([a-fA-F0-9]{4})/g, function (g, m1) {
        return String.fromCharCode(parseInt(m1, 16));
    });
}

function toUTF16(codePoint) {
    var TEN_BITS = parseInt('1111111111', 2);
    function u(codeUnit) {
        return '\\u' + codeUnit.toString(16).toUpperCase();
    }

    if (codePoint <= 0xFFFF) {
        return u(codePoint);
    }
    codePoint -= 0x10000;

    // Shift right to get to most significant 10 bits
    var leadSurrogate = 0xD800 + (codePoint >> 10);

    // Mask to get least significant 10 bits
    var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);

    return u(leadSurrogate) + u(tailSurrogate);
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/chat/chat.page.ts